/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowphotomiddle3Inputs */

const en_aiflowphotomiddle3 = /** @type {(inputs: Aiflowphotomiddle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Middle`)
};

const de_aiflowphotomiddle3 = /** @type {(inputs: Aiflowphotomiddle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitte`)
};

/**
* | output |
* | --- |
* | "Middle" |
*
* @param {Aiflowphotomiddle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowphotomiddle3 = /** @type {((inputs?: Aiflowphotomiddle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowphotomiddle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowphotomiddle3(inputs)
	return de_aiflowphotomiddle3(inputs)
});
export { aiflowphotomiddle3 as "aiFlowPhotoMiddle" }